import {
  CLOUDINARY_BROWSE_LOADING,
  CLOUDINARY_IMAGES,
} from "../types";

const CloudinaryReducer = (state, action) => {
  switch (action.type) {
    case CLOUDINARY_BROWSE_LOADING:
      return { ...state, browse_loading: action.payload };

    case CLOUDINARY_IMAGES:
      const images = action.payload.resources;
      let image_next_cursor = null;

      if (images.length < action.payload.total_count) {
        image_next_cursor = action.payload.next_cursor;
      } else {
        image_next_cursor = null;
      }

      return { ...state, images, image_next_cursor };

    default:
      return state;
  }
};

export default CloudinaryReducer;